import { css } from '@repo/pandacss/css';

/* === RewardsBreakdown === */
export const rewardsBreakdownGrid = css({
  display: 'grid',
  gridTemplateColumns: '[auto 1fr]',
  gap: '2',
});

/* === NerdwalletsTake === */
export const nwTakeBottomLine = css({
  mb: '3',
});

export const nwTakeBottomLineText = css({
  lineHeight: '[1.5]',
});

/* === NerdwalletsTake > ProsCons === */
export const prosConsContainer = css({
  display: 'flex',
  width: '[100%]',
  flexDirection: 'column',
  _pcMd: {
    flexDirection: 'row',
    gap: '3',
  },
});

/* === ImageApplyNow === */
export const imageApplyNowLink = css({
  position: 'relative',
  display: 'flex',
  minWidth: '[144px]',
  height: '[90px]',
  _pcMd: {
    minWidth: '[163px]',
    height: '[105px]',
  },
});

/* === HeaderBadges === */
const headerBadgesWrapperBase = css.raw({
  pt: '3',
  _pcMd: {
    pt: '3.5',
  },
});

export const headerBadgesWrapper = css(headerBadgesWrapperBase);

export const headerBadgesWrapperWithAward = css(headerBadgesWrapperBase, {
  _pcMd: {
    pb: '3',
  },
});

export const headerBadgesWrapperWithoutAward = css(headerBadgesWrapperBase, {
  _pcMd: {
    pb: '2',
  },
});

export const awardAndLtoBadgesRow = css({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '3',
  flexDirection: 'column',
  _pcSm: {
    flexDirection: 'row',
  },
});

export const badgesFlexRow = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '3',
  justifyContent: 'space-between',
  _pcMd: {
    flexDirection: 'row',
    gap: '0',
  },
});

export const badgesInnerRow = css({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const promotionalBadgeDesktopOnly = css({
  display: 'none',
  ml: 'auto',
  _pcMd: {
    display: 'block',
  },
});

/* === Accordion === */
export const accordionSummaryContent = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  pt: '[12px]',
  pb: '[12px]',
});

export const accordionSummaryInner = css({
  display: 'flex',
  alignItems: 'center',
  gap: '2',
});

export const accordionSummaryTitle = css({
  fontSize: '[1rem]',
  lineHeight: '[150%]',
  fontFamily: 'gotham',
  fontWeight: '[500]',
  _pcMd: {
    fontSize: '[18px]',
  },
});

/**
 * The original CSS used .accordionExpandIcon.accordionExpandIcon (doubled selector)
 * for specificity to override MUI styles. The styles are defined once here;
 * specificity will need to be handled at the component level.
 */
export const accordionExpandIcon = css({
  color: 'common.black',
  boxSize: '[20px]',
  _pcMd: {
    boxSize: 'icon.medium',
  },
});

export const accordionSummaryProps = css({
  pl: '3',
  pr: '3',
  _pcMd: {
    pl: '3.5',
    pr: '3.5',
    pt: '2',
    pb: '2',
  },
});

export const accordionDetails = css({
  borderTopWidth: '[1px]',
  borderTopStyle: 'solid',
  borderTopColor: 'grey.200',
  '& > summary:hover': {
    backgroundColor: 'blues.lightest',
    outlineWidth: '[2px]',
    outlineStyle: 'solid',
    outlineColor: 'blues.light',
    position: 'relative',
    zIndex: 1,
  },
  '&:last-child > summary:hover': {
    borderBottomRadius: 'md',
  },
  '&:last-child[open] > summary:hover': {
    borderBottomLeftRadius: '[0]',
    borderBottomRightRadius: '[0]',
  },
});

export const accordionContentPanel = css({
  pt: '3',
  pr: '3',
  pb: '3',
  pl: '3',
  _pcMd: {
    pt: '2',
    pr: '5',
    pb: '3.5',
    pl: '5',
  },
});
